<template>
    <div v-if="client">
        <!-- theme -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Theme</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.style.theme"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- logo -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Logo</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.style.logo"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- mobile logo -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Mobile logo</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.style.logoMobile"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>
        <!-- email logo -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Email logo</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input
                            v-model="client.settings.viewSettings.style.logoEmail"
                            class="input oc-input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

import ContentStringRef from '../../../../common/content/string/content-string-ref.vue';

export default {
    name: 'client-settings-view-style',
    components: { ContentStringRef },
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/style.vue